export default __webpack_public_path__ + "ed0aecef2e402c3e9dc63ef7c4c9a31e.png";